export default __webpack_public_path__ + "static/alison-ee4403f0498d879a6cb85141a3e720e8.jpg";